import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyASsoBoIRYDowWqRMZy6_ipM2kmz-4hDWQ',
  authDomain: 'app-stx-tg.firebaseapp.com',
  projectId: 'app-stx-tg',
  storageBucket: 'app-stx-tg.firebasestorage.app',
  messagingSenderId: '745410351329',
  appId: '1:745410351329:web:0b97e116cdc07cc793a7a0',
  measurementId: 'G-S64B3101K3',
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
